








import { CompanyUser } from '@/models/users'
import Vue from 'vue'

interface Data {
  badge: number
}

interface Computed {
  userFI: string
  hasAvatar: boolean
  avatar: string
}

interface Props {
  fi?: string
  user?: CompanyUser
  color?: 'success' | 'danger' | 'pending'
}

export default Vue.extend<Data, {}, Computed, Props>({
  props: {
    fi: {
      type: String,
      required: false,
      default: '?',
    },
    user: {
      type: Object,
      required: false,
    },
    color: {
      default: () => undefined,
    },
  },

  data: () => ({
    badge: 0,
  }),

  computed: {
    userFI(): string {
      let str = ''
      if (this.user?.fname || this.user?.lname) {
        if (this.user?.fname && this.user.fname[0]) {
          str += this.user.fname[0]
        }
        if (this.user?.lname && this.user.lname[0]) {
          str += this.user.lname[0]
        }
      } else if (this.fi) {
        str = this.fi
      }
      return str
    },

    hasAvatar(): boolean {
      return !!(this.avatar?.length > 0)
    },

    avatar(): string {
      return this.user?.avatar || ''
    },
  },
})
